
	export default {
		props: ['section'],
		data(){
			return {
				hover: false,
				showingChildren: false
			}
		}
	}
